// 시스템 설정/IP 접근제어 타입 — packages/shared/src/settings.ts 의 zod 스키마와 동일 키 (admin 은 shared 를 import 하지 않음)
export type IpAccessMode = 'allow_all' | 'deny_all';

export interface SystemSettings {
  // 검사/업로드
  maxUploadMb: number; // 1~100
  rateLimitPerMinute: number;
  rateLimitWindowSeconds: number;
  engineClamavEnabled: boolean;
  engineYaraEnabled: boolean;
  engineHashBlacklistEnabled: boolean;
  magicBytesCheckEnabled: boolean;
  // 격리/로그 보관
  quarantineRetentionDays: number;
  scanLogRetentionDays: number;
  // Webhook
  webhookMaxAttempts: number;
  webhookRetryDelaySeconds: number;
  webhookTimeoutMs: number;
  // 관리자 보안
  adminMaxLoginAttempts: number;
  adminLockoutMinutes: number;
  adminIdleTimeoutMinutes: number;
  // IP 접근제어 — 폼 저장과 별개로 즉시 반영
  ipAccessMode: IpAccessMode;
}

/** 폼으로 편집·저장하는 부분 (ipAccessMode 제외) */
export type SettingsForm = Omit<SystemSettings, 'ipAccessMode'>;

/** 서버 로드 실패 시 표시용 기본값 — shared defaultSettings() 와 동일 (env 기본값 기준) */
export const DEFAULT_SYSTEM_SETTINGS: SystemSettings = {
  maxUploadMb: 100,
  rateLimitPerMinute: 120,
  rateLimitWindowSeconds: 60,
  engineClamavEnabled: true,
  engineYaraEnabled: true,
  engineHashBlacklistEnabled: true,
  magicBytesCheckEnabled: true,
  quarantineRetentionDays: 30,
  scanLogRetentionDays: 90,
  webhookMaxAttempts: 5,
  webhookRetryDelaySeconds: 60,
  webhookTimeoutMs: 10000,
  adminMaxLoginAttempts: 5,
  adminLockoutMinutes: 5,
  adminIdleTimeoutMinutes: 10,
  ipAccessMode: 'allow_all',
};

export interface IpAllowItem {
  id: string;
  cidr: string;
  note: string | null;
  createdAt: string;
}

export interface SettingsResponse { settings: SystemSettings; defaults: SystemSettings; clientIp: string }
export interface IpAccessResponse { mode: IpAccessMode; clientIp: string; items: IpAllowItem[] }
